import { RemoteCollectionStore } from "@softline/core";
import { Lagersymbol } from "../types/lagersymbol";


export const LagersymbolStore = RemoteCollectionStore.create<Lagersymbol>()
